import ProductType from "../types/ProductType";
import POProductType from "../types/POProductType";
import OrderType from "../types/OrderType";

interface ProductAction {
  type: string;
  payload?: any;
}

const initial_state = {
  productList: [],
  currentPage: 0,
  lastPage: 0,
  totalData: 0,
  from: 0,
  to: 0,
  addVariant: null,
  variantProductList: null,
  colorList: [],
  updateVariant: null,
  productDetails: null,
  poProductList: [],
  recentOrders: [],
  termsAndConditions: "",
  deliveryCharge: "",
  minOrderAmount: "",
  productViewStatus: "",
  requestStatus: "",
  buyerDataList: "",
  downloadproductList: "",
};

const ProductReducer = (state = initial_state, action: ProductAction) => {
  switch (action.type) {
    case ProductType.SET_ADD_PRODUCT:
      return {
        ...state,
      };

    case ProductType.SET_PRODUCT_LIST:
      return {
        ...state,
        productList: action.payload.data,
        currentPage: action.payload.currentPage,
        lastPage: action.payload.lastPage,
        totalData: action.payload.totalData,
        from: action.payload.from,
        to: action.payload.to,
      };

    case ProductType.SET_ADD_VARIANT:
      return {
        ...state,
      };

    case ProductType.SET_VARIANT_PRODUCT_LIST:
      return {
        ...state,
        variantProductList: action.payload,
      };

    case ProductType.CHANGE_PRODUCT_STATUS: {
      const { id, status } = action.payload;
      const data: any = [...state.productList];
      const findIndex = data.findIndex((d: any) => d.id === id);
      if (findIndex > -1) {
        data[findIndex].status = status;
      }

      return {
        ...state,
        productList: data,
      };
    }

    case ProductType.SET_ACTIVATE_ECOM_PRODUCT:
      return {
        ...state,
      };

    case ProductType.SET_COLORS: {
      return {
        ...state,
        colorList: action.payload,
      };
    }

    case ProductType.DELETE_VARIANT: {
      const productId = action.payload.id;

      const data: any = state.variantProductList;

      const findIndex = data.findIndex((d: any) => d.id === productId);

      if (findIndex > -1) {
        data.splice(findIndex, 1);
      }

      return {
        ...state,
        variantProductList: data,
      };
    }

    case ProductType.UPDATE_VARIANT:
      return {
        ...state,
      };

    case ProductType.SET_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: action.payload,
      };

    case ProductType.UPDATE_PRODUCT:
      return {
        ...state,
      };
    case ProductType.GET_PO_PRODUCT_LIST: {
      return {
        ...state,
        poProductList: action.payload.data,
        termsAndConditions: action.payload.terms_conditions,
        deliveryCharge: action.payload.delivery_charge,
        minOrderAmount: action.payload.min_order_amount,
        productViewStatus: action.payload.product_view_status,
        requestStatus: action.payload.requestStatus,
      };
    }

    case POProductType.SET_ADD_PO_PRODUCT: {
      const data: any = [...state.poProductList];

      return {
        ...state,
        productList: data,
      };
    }

    case POProductType.SET_UPDATE_PO_PRODUCT: {
      const data: any = [...state.poProductList];

      return {
        ...state,
        productList: data,
      };
    }

    case OrderType.GET_RECENT_ORDERS: {
      return {
        ...state,
        recentOrders: action.payload.data,
      };
    }

    case ProductType.SET_BUYER_LIST:
      return {
        ...state,
        buyerDataList: action.payload.data,
      };

    case ProductType.MAP_PRODUCT:
      return {
        ...state,
      };

    case ProductType.DOWNLOAD_PRODUCT_LIST:
      return {
        ...state,
        downloadproductList: action.payload.data,
      };

    default:
      return state;
  }
};

export default ProductReducer;
